module.exports = __webpack_public_path__ + "static/media/battery_eng_06.72aae211.png";